import { configureStore } from '@reduxjs/toolkit';
import userReducer from './user/userSlice';
import newsfeedReducer from './newsfeed/newsfeedSlice';
import priceprofileReducer from './priceprofile/priceprofileSlice';
import marketReducer from './market/marketSlice';
import theReducer from './the/theSlice';
import ttfReducer from './ttf/ttfSlice';
import marketplaceReducer from './marketplace/marketplaceSlice';
import intradayReducer from './intraday/intradaySlice';
import pegnordReducer from './pegnord/pegnordSlice';
import orderReducer from './order/orderSlice';
import watchlistReducer from './watchlist/watchlistSlice';
import accountReducer from './settings/account/accountSlice';
import endpointReducer from './settings/endpoint/endpointSlice';
import notificationReducer from './notification/notificationSlice';
import cheReducer from './che/cheSlice';
import chReducer from './ch/chSlice';
import announcementReducer from './announcement/announcementSlice';
import overviewReducer from './overview/overviewSlice';
import chatReducer from './chat/chatSlice';
import hedgeMarginReducer from './hedgeMargin/hedgeMarginSlice';
import demandReducer from './tradingadvisor/tradingAdvisorSlice';
import { chatApi } from './chat/chatApi';
import tradingAdvisorReducer from './tradingadvisor/tradingAdvisorSlice';
import { knowledgeBaseApi } from './chat/knowledgeBase';

// ENERGY PORTFOLIO
import clientReducer from './energyportfolio/client/clientSlice';
import portfolioReducer from './energyportfolio/portfolio/portfolioSlice';
import energyportfolioendpointReducer from './energyportfolio/endpoints/endpointSlice';
import exchangeReducer from './energyportfolio/exchange/exchangeSlice';
import brokerReducer from './energyportfolio/broker/brokerSlice';
import counterPartyReducer from './energyportfolio/counterparty/counterpartySlice';
import forecastingReducer from './energyportfolio/forecasting/forecastingSlice';
import consumptionReducer from './energyportfolio/consumption/consumptionSlice';
import monthlyConsumptionReducer from './energyportfolio/consumption/consumptionMontlySlice';
import hedgesReducer from './energyportfolio/hedges/hedgeSlice';
import forwardReducer from './energyportfolio/forward/forwardSlice';
import optionReducer from './energyportfolio/option/optionSlice';
import searchReducer from './energyportfolio/search/searchSlice';
import statisticsReducer from './energyportfolio/statistics/statisticsSlice';
import transactionReducer from './energyportfolio/transaction/transactionSlice';


export const store = configureStore({
    reducer: {
        user: userReducer,
        newsfeed: newsfeedReducer,
        priceprofile: priceprofileReducer,
        market: marketReducer,
        the: theReducer,
        ttf: ttfReducer,
        marketplace: marketplaceReducer,
        intraday: intradayReducer,
        pegnord: pegnordReducer,
        order: orderReducer,
        watchlist: watchlistReducer,
        account: accountReducer,
        endpoint: endpointReducer,
        notification: notificationReducer,
        che: cheReducer,
        ch: chReducer,
        announcement: announcementReducer,
        overview: overviewReducer,
        chat: chatReducer,
        hedgeMargin: hedgeMarginReducer,
        demand: demandReducer,
        demands: tradingAdvisorReducer,
        // [tradingAdvisorApi.reducerPath]: tradingAdvisorApi.reducer, // Add RTK Query reducer
        [chatApi.reducerPath]: chatApi.reducer,
        [knowledgeBaseApi.reducerPath]: knowledgeBaseApi.reducer, // Add RTK Query reducer for knowledge base
        // ENERGY PORTFOLIO
        client: clientReducer,
        portfolio: portfolioReducer,
        endpoints: energyportfolioendpointReducer,
        exchanges: exchangeReducer,
        broker: brokerReducer,
        counterParty: counterPartyReducer,
        forecasts: forecastingReducer,
        hedges: hedgesReducer,
        forward: forwardReducer,
        option: optionReducer,
        search: searchReducer,
        consumption: consumptionReducer,
        monthlyConsumption: monthlyConsumptionReducer,
        statistics: statisticsReducer,
        transaction: transactionReducer,

    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(chatApi.middleware, knowledgeBaseApi.middleware) // Add RTK Query middleware
});
